/* Olfé: filters op de collectiepagina.
   Werkt op de productkaarten zelf (één kaart per kleur): elke kaart draagt data-olfe-colors,
   data-olfe-sizes (alleen maten die op voorraad zijn), data-olfe-type en data-olfe-support. */
(function () {
  'use strict';

  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL'];
  var SUPPORT_ORDER = ['medium', 'high'];
  var COLOR_FALLBACK = {
    zwart: '#111111', black: '#111111', navy: '#1f2a44', 'pine-groen': '#1f4d3a', 'midnight-blauw': '#191970',
    cherry: '#7a1f2b', 'ice-blue': '#bcd4e6', 'off-white': '#f3efe6', offwhite: '#f3efe6', olijf: '#5b5f3a',
    'bordeaux-rood': '#6d1a2a', wit: '#ffffff', grijs: '#8a8a8a', beige: '#e6d9c3'
  };
  var ICON_CHEVRON = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2.5 5.5 8 11l5.5-5.5"></path></svg>';

  function handleize(value) {
    return String(value).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function unique(list) {
    return list.filter(function (value, index) { return list.indexOf(value) === index; });
  }

  function init(root) {
    if (root.oflReady) return;
    var grid = document.querySelector('#ProductGridContainer .card-grid');
    if (!grid) return;
    root.oflReady = true;

    var labels = JSON.parse(root.getAttribute('data-labels') || '{}');
    var sortOptions = JSON.parse(root.getAttribute('data-sort') || '[]');
    var currentSort = root.getAttribute('data-sort-current') || '';
    var storageKey = 'olfe-filters:' + window.location.pathname;

    var groups = [
      { key: 'colors', label: labels.color, style: 'swatch' },
      { key: 'sizes', label: labels.size, style: 'grid' },
      { key: 'type', label: labels.type, style: 'check' },
      { key: 'support', label: labels.support, style: 'check' }
    ];
    var state = { colors: [], sizes: [], type: [], support: [] };
    var openKeys = [];
    var lastFocus = null;

    var countEl = root.querySelector('[data-ofl-count]');
    var pillsEl = root.querySelector('[data-ofl-pills]');
    var emptyEl = root.querySelector('[data-ofl-empty]');
    var sortSelect = root.querySelector('[data-ofl-sort]');

    /* Paneel en overlay staan in de sectie, maar horen direct onder body (position: fixed). */
    var old = document.querySelectorAll('body > .ofl-drawer, body > .ofl-overlay');
    Array.prototype.forEach.call(old, function (el) { el.remove(); });
    var overlay = root.querySelector('.ofl-overlay');
    var drawer = root.querySelector('.ofl-drawer');
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
    var bodyEl = drawer.querySelector('[data-ofl-groups]');
    var clearBtn = drawer.querySelector('[data-ofl-clear]');
    var closeBtn = drawer.querySelector('.ofl-drawer__close');

    try {
      var saved = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
      if (saved) {
        Object.keys(state).forEach(function (key) {
          if (Array.isArray(saved[key])) state[key] = saved[key];
        });
      }
    } catch (error) { /* geen opslag beschikbaar */ }

    /* Een link (bv. uit het menu) kan een filter voorselecteren: ?f_support=high of ?f_type=Tanktop,T-shirt.
       Dat vervangt een eerder bewaarde keuze; de parameter verdwijnt daarna uit de adresbalk. */
    try {
      var params = new URLSearchParams(window.location.search);
      var fromUrl = false;
      groups.forEach(function (group) {
        var raw = params.get('f_' + group.key);
        if (raw === null) return;
        if (!fromUrl) {
          Object.keys(state).forEach(function (key) { state[key] = []; });
          fromUrl = true;
        }
        var wanted = raw.split(',').map(function (value) { return value.trim().toLowerCase(); }).filter(Boolean);
        var all = [];
        cards().forEach(function (card) { all = all.concat(values(card, group.key)); });
        state[group.key] = unique(all).filter(function (value) { return wanted.indexOf(value.toLowerCase()) > -1; });
        params.delete('f_' + group.key);
      });
      if (fromUrl && window.history.replaceState) {
        var query = params.toString();
        window.history.replaceState(window.history.state, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
      }
    } catch (error) { /* oude browser: geen voorselectie */ }

    function cards() {
      return Array.prototype.slice.call(grid.querySelectorAll('.card.product-card'));
    }

    function values(card, key) {
      var raw = card.getAttribute('data-olfe-' + key) || '';
      return unique(raw.split('|').map(function (value) { return value.trim(); }).filter(Boolean));
    }

    /* Kaarten die iets anders al verbergt (bv. een tijdelijk verborgen kleur) tellen niet mee. */
    function hiddenElsewhere(card) {
      return card.style.getPropertyValue('display') === 'none';
    }

    function matches(card, skipKey) {
      return groups.every(function (group) {
        if (group.key === skipKey || !state[group.key].length) return true;
        var cardValues = values(card, group.key);
        return state[group.key].some(function (value) { return cardValues.indexOf(value) > -1; });
      });
    }

    function optionLabel(group, value) {
      if (group.key === 'support') return value === 'high' ? labels.supportHigh : labels.supportMedium;
      return value;
    }

    function sortValues(group, list) {
      var order = group.key === 'sizes' ? SIZE_ORDER : group.key === 'support' ? SUPPORT_ORDER : null;
      return list.sort(function (a, b) {
        if (order) {
          var ia = order.indexOf(group.key === 'sizes' ? a.toUpperCase() : a);
          var ib = order.indexOf(group.key === 'sizes' ? b.toUpperCase() : b);
          if (ia === -1) ia = 99;
          if (ib === -1) ib = 99;
          if (ia !== ib) return ia - ib;
        }
        return a.localeCompare(b);
      });
    }

    function collect() {
      var live = cards().filter(function (card) { return !hiddenElsewhere(card); });
      return groups.map(function (group) {
        var all = [];
        live.forEach(function (card) { all = all.concat(values(card, group.key)); });
        var list = sortValues(group, unique(all));
        /* Een eerder gekozen waarde die niet meer bestaat laten we vallen. */
        state[group.key] = state[group.key].filter(function (value) { return list.indexOf(value) > -1; });
        var options = list.map(function (value) {
          var count = live.filter(function (card) {
            return values(card, group.key).indexOf(value) > -1 && matches(card, group.key);
          }).length;
          return { value: value, count: count };
        });
        return { group: group, options: options };
      }).filter(function (entry) { return entry.options.length > 1; });
    }

    function swatchStyle(colorName) {
      var key = handleize(colorName);
      var el = grid.querySelector('li[data-qa-color-key="' + key + '"] .color-swatch');
      if (el) {
        var cs = window.getComputedStyle(el);
        if (cs.backgroundImage && cs.backgroundImage !== 'none') return 'background-image:' + cs.backgroundImage.replace(/"/g, "'") + ';';
        if (cs.backgroundColor && cs.backgroundColor !== 'rgba(0, 0, 0, 0)') return 'background-color:' + cs.backgroundColor + ';';
      }
      return COLOR_FALLBACK[key] ? 'background-color:' + COLOR_FALLBACK[key] + ';' : '';
    }

    function activeCount() {
      return groups.reduce(function (total, group) { return total + state[group.key].length; }, 0);
    }

    function apply() {
      var visible = 0;
      cards().forEach(function (card) {
        var show = matches(card);
        card.classList.toggle('ofl-hide', !show);
        if (show && !hiddenElsewhere(card)) visible += 1;
      });
      if (countEl) countEl.textContent = visible + ' ' + (visible === 1 ? labels.resultOne : labels.resultMany);
      if (emptyEl) emptyEl.hidden = visible > 0;
      if (clearBtn) clearBtn.hidden = activeCount() === 0;
      try { window.sessionStorage.setItem(storageKey, JSON.stringify(state)); } catch (error) { /* geen opslag */ }
      return visible;
    }

    function renderPills(entries) {
      Array.prototype.forEach.call(pillsEl.querySelectorAll('[data-ofl-group]'), function (el) { el.remove(); });
      entries.forEach(function (entry) {
        var selected = state[entry.group.key].length;
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'ofl__pill' + (selected ? ' is-active' : '');
        pill.setAttribute('data-ofl-group', entry.group.key);
        pill.textContent = entry.group.label + (selected ? ' (' + selected + ')' : '');
        pillsEl.appendChild(pill);
      });
      var main = pillsEl.querySelector('[data-ofl-open]');
      if (main) main.classList.toggle('is-active', activeCount() > 0);
    }

    function renderGroups(entries) {
      Array.prototype.forEach.call(bodyEl.querySelectorAll('.ofl-group:not(.ofl-group--sort)'), function (el) { el.remove(); });
      entries.forEach(function (entry) {
        var group = entry.group;
        var isOpen = openKeys.indexOf(group.key) > -1;
        var selected = state[group.key].length;
        var wrap = document.createElement('div');
        wrap.className = 'ofl-group' + (isOpen ? ' is-open' : '');
        wrap.setAttribute('data-ofl-group-panel', group.key);
        var listClass = group.style === 'grid' ? 'ofl-options ofl-options--grid' : group.style === 'check' ? 'ofl-options ofl-options--list' : 'ofl-options';
        var html = '<h3 style="margin:0"><button type="button" class="ofl-group__toggle" aria-expanded="' + isOpen + '" aria-controls="OflPanel-' + group.key + '">' +
          '<span>' + group.label + (selected ? '<span class="ofl-group__badge">(' + selected + ')</span>' : '') + '</span>' + ICON_CHEVRON + '</button></h3>' +
          '<div class="ofl-group__panel" id="OflPanel-' + group.key + '"><div class="ofl-group__inner"><fieldset class="' + listClass + '"><legend class="sr-only">' + group.label + '</legend>';
        entry.options.forEach(function (option, index) {
          var id = 'Ofl-' + group.key + '-' + index;
          var checked = state[group.key].indexOf(option.value) > -1;
          var disabled = option.count === 0 && !checked;
          var input = '<input type="checkbox" id="' + id + '" data-ofl-key="' + group.key + '" value="' + option.value.replace(/"/g, '&quot;') + '"' + (checked ? ' checked' : '') + (disabled ? ' disabled' : '') + '>';
          var text = optionLabel(group, option.value);
          if (group.style === 'check') {
            html += '<label class="ofl-opt ofl-opt--check" for="' + id + '">' + input + '<span class="ofl-opt__face"><span>' + text + ' <span class="ofl-opt__count">(' + option.count + ')</span></span></span></label>';
          } else if (group.style === 'swatch') {
            html += '<label class="ofl-opt ofl-opt--pill" for="' + id + '">' + input + '<span class="ofl-opt__face"><span class="ofl-dot" style="' + swatchStyle(option.value) + '"></span>' + text + '</span></label>';
          } else {
            html += '<label class="ofl-opt ofl-opt--pill" for="' + id + '">' + input + '<span class="ofl-opt__face">' + text + '</span></label>';
          }
        });
        html += '</fieldset></div></div>';
        wrap.innerHTML = html;
        bodyEl.appendChild(wrap);
      });
    }

    function renderSort() {
      var existing = bodyEl.querySelector('.ofl-group--sort');
      if (existing || !sortOptions.length) return;
      var wrap = document.createElement('div');
      wrap.className = 'ofl-group ofl-group--sort';
      wrap.setAttribute('data-ofl-group-panel', 'sort');
      var html = '<h3 style="margin:0"><button type="button" class="ofl-group__toggle" aria-expanded="false" aria-controls="OflPanel-sort"><span>' + labels.sort + '</span>' + ICON_CHEVRON + '</button></h3>' +
        '<div class="ofl-group__panel" id="OflPanel-sort"><div class="ofl-group__inner"><fieldset class="ofl-options ofl-options--list"><legend class="sr-only">' + labels.sort + '</legend>';
      sortOptions.forEach(function (option, index) {
        var id = 'Ofl-sort-' + index;
        html += '<label class="ofl-opt ofl-opt--check ofl-opt--radio" for="' + id + '"><input type="radio" name="ofl-sort" id="' + id + '" value="' + option.value + '"' + (option.value === currentSort ? ' checked' : '') + '><span class="ofl-opt__face"><span>' + option.name + '</span></span></label>';
      });
      html += '</fieldset></div></div>';
      wrap.innerHTML = html;
      bodyEl.insertBefore(wrap, bodyEl.firstChild);
    }

    function refresh() {
      apply();
      var entries = collect();
      renderPills(entries);
      renderGroups(entries);
    }

    function setSort(value) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    }

    function focusables() {
      return Array.prototype.filter.call(
        drawer.querySelectorAll('button, input, [href], [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && el.getClientRects().length > 0 && window.getComputedStyle(el).visibility !== 'hidden'; }
      );
    }

    function open(groupKey) {
      lastFocus = document.activeElement;
      openKeys = groupKey ? [groupKey] : [];
      refresh();
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      document.documentElement.style.overflow = 'hidden';
      window.setTimeout(function () {
        var target = groupKey && drawer.querySelector('[data-ofl-group-panel="' + groupKey + '"] .ofl-group__toggle');
        (target || closeBtn).focus({ preventScroll: true });
        if (target) target.scrollIntoView({ block: 'nearest' });
      }, 60);
    }

    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    }

    root.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-ofl-group]');
      if (pill) return open(pill.getAttribute('data-ofl-group'));
      if (event.target.closest('[data-ofl-open]')) return open(null);
      if (event.target.closest('[data-ofl-clear]')) {
        Object.keys(state).forEach(function (key) { state[key] = []; });
        refresh();
      }
    });

    drawer.addEventListener('click', function (event) {
      var toggle = event.target.closest('.ofl-group__toggle');
      if (toggle) {
        var group = toggle.closest('.ofl-group');
        var isOpen = group.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        var key = group.getAttribute('data-ofl-group-panel');
        var at = openKeys.indexOf(key);
        if (isOpen && at === -1) openKeys.push(key);
        if (!isOpen && at > -1) openKeys.splice(at, 1);
        return;
      }
      if (event.target.closest('[data-ofl-clear]')) {
        Object.keys(state).forEach(function (key) { state[key] = []; });
        refresh();
        return;
      }
      if (event.target.closest('[data-ofl-close]')) close();
    });

    drawer.addEventListener('change', function (event) {
      var input = event.target;
      if (input.name === 'ofl-sort') return setSort(input.value);
      var key = input.getAttribute('data-ofl-key');
      if (!key) return;
      var list = state[key];
      var index = list.indexOf(input.value);
      if (input.checked && index === -1) list.push(input.value);
      if (!input.checked && index > -1) list.splice(index, 1);
      var scrollTop = bodyEl.scrollTop;
      var focusId = input.id;
      refresh();
      bodyEl.scrollTop = scrollTop;
      var again = document.getElementById(focusId);
      if (again) again.focus({ preventScroll: true });
    });

    overlay.addEventListener('click', close);

    document.addEventListener('keydown', function (event) {
      if (!drawer.classList.contains('is-open')) return;
      if (event.key === 'Escape') return close();
      if (event.key !== 'Tab') return;
      var list = focusables();
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () { setSort(sortSelect.value); });
    }

    renderSort();
    refresh();
    document.documentElement.classList.remove('ofl-pending');
    /* Kleuren die later door een ander script worden verborgen: tellingen daarna bijwerken. */
    window.addEventListener('load', function () { window.setTimeout(refresh, 400); });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.ofl'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
